// extracted by mini-css-extract-plugin
export default {"wrap":"Footer_wrap__kerNl"};